import type { Narrative } from '../hooks/useCompanyNarratives';
import Carousel from '@/components/Carousel';
import { StyledEmbla } from '@/components/Carousel/styled';
import { NarrativeCardPopulated } from '@/components/NarrativeCard';
import { useTracking } from 'react-tracking';
import { cn } from '@simplywallst/ui-core/next';
import { NarrativeInvalidationBoundary } from '../../NarrativeInvalidationBoundary';

type Props = {
  canonicalUrl: string;
  narratives: Narrative[];
};

export const CompanyNarrativesList = ({ narratives }: Props) => {
  const { trackEvent } = useTracking();

  const handleOnClick = (narrative: (typeof narratives)[number]) => {
    const { id, company } = narrative;
    return trackEvent({
      action: 'click',
      modifier: 'view',
      narrativeId: id,
      companyId: company?.id,
      uniqueSymbol: company?.tickerSymbol,
    });
  };
  const narrativeCount = narratives.length;
  const hasMoreThanOneNarrative = narrativeCount > 1;

  return (
    <NarrativeInvalidationBoundary
      onSetPrimary={({ invalidatePriority }) =>
        invalidatePriority(['narrative-company-report-list'])
      }
    >
      <StyledEmbla>
        <Carousel
          align="center"
          containScroll="trimSnaps"
          showArrows={hasMoreThanOneNarrative}
          showGradient={hasMoreThanOneNarrative}
          totalSlides={narrativeCount}
        >
          <div
            role="list"
            className={cn(
              'grid w-full gap-x1',
              !hasMoreThanOneNarrative && 'grid-cols-[minmax(317px,500px)]'
            )}
            style={{
              gridTemplateColumns: `repeat(${narrativeCount}, 317px)`,
            }}
          >
            {narratives.map((narrative) => (
              <div role="listitem" key={narrative.id}>
                <NarrativeCardPopulated
                  narrative={narrative}
                  onClick={() => handleOnClick(narrative)}
                />
              </div>
            ))}
            {/*  TODO: Uncomment this when we have added narrative mini valuator
            <div role="listitem">
              <NarrativeMiniValuator
                companyCanonicalUrl={canonicalUrl}
                className="bg-surface-2"
                hideCompanySelect
              />
            </div> */}
          </div>
        </Carousel>
      </StyledEmbla>
    </NarrativeInvalidationBoundary>
  );
};
